const hasTargetEvent = (hint?: unknown): hint is { event: { target: HTMLElement } } => {
  return (
    typeof hint === 'object' &&
    hint !== null &&
    'event' in hint &&
    typeof hint.event === 'object' &&
    hint.event !== null &&
    'target' in hint.event &&
    hint.event.target !== null
  );
};

export const isButtonElement = (hint?: unknown) => {
  if (!hasTargetEvent(hint)) {
    return false;
  }

  return Boolean(hint.event.target.closest('button'));
};
